module.exports = __webpack_public_path__ + "img/2024122501.7df6f85b.png";